import { render, staticRenderFns } from "./enterprise_add.vue?vue&type=template&id=2b458a7a&"
import script from "./enterprise_add.vue?vue&type=script&lang=js&"
export * from "./enterprise_add.vue?vue&type=script&lang=js&"
import style0 from "./enterprise_add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports